import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function WebDevelopment() {
  return (
    <div className="pt-16">
      <Helmet>
        <title>Best Website Development Company in Chhindwara | Zolo Service</title>
        <meta name="description" content="Professional website development services in Chhindwara. Custom, responsive websites for businesses across India. Contact Zolo Service for affordable web design!" />
        <meta name="keywords" content="website development Chhindwara, web design company Chhindwara, ecommerce website development Chhindwara, responsive web design Chhindwara, custom website development India, professional website designers India" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Service",
              "serviceType": "Web Development",
              "provider": {
                "@type": "LocalBusiness",
                "name": "Zolo Service",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Chhindwara",
                  "addressRegion": "Madhya Pradesh",
                  "postalCode": "480001",
                  "addressCountry": "India"
                },
                "telephone": "+91-9993547121",
                "priceRange": "₹₹"
              },
              "areaServed": ["Chhindwara", "Madhya Pradesh", "India"],
              "description": "Custom, responsive websites to boost your online presence in Chhindwara and across India.",
              "offers": {
                "@type": "Offer",
                "priceSpecification": {
                  "@type": "PriceSpecification",
                  "priceCurrency": "INR"
                }
              }
            }
          `}
        </script>
      </Helmet>
      
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url('/images/services/web-development-detail.jpg')` }}
          aria-hidden="true"
        ></div>
        <div className="relative container mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Professional Website Development Services in Chhindwara</h1>
            <p className="text-xl mb-8">
              Custom, responsive websites to boost your online presence in Chhindwara and across India.
            </p>
            <Link 
              to="/contact" 
              className="inline-block bg-zolo-orange hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-md transition duration-300"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold mb-6">Boost Your Online Presence with Custom Website Development</h2>
            
            <p className="text-lg text-gray-700 mb-6">
              At Zolo Service, we specialize in creating stunning, functional websites that help businesses in Chhindwara and across India establish a powerful online presence. Our web development services are tailored to meet your specific needs and goals, ensuring your website stands out from the competition.
            </p>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Website Development Services Include:</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Custom Website Design</h4>
                  <p className="text-gray-700">
                    Unique, brand-aligned websites designed specifically for your business needs and target audience in Chhindwara and beyond.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Responsive Web Development</h4>
                  <p className="text-gray-700">
                    Mobile-friendly websites that look and function perfectly on all devices and screen sizes for optimal user experience.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">E-Commerce Website Development</h4>
                  <p className="text-gray-700">
                    Online stores with secure payment gateways, inventory management, and user-friendly interfaces for businesses in Chhindwara.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">CMS Integration</h4>
                  <p className="text-gray-700">
                    WordPress and other content management systems to help you easily update your website without technical knowledge.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Why Choose Our Web Development Services in Chhindwara?</h3>
              
              <ul className="space-y-4 text-lg text-gray-700">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Local Expertise:</strong> As a Chhindwara-based company, we understand the local market and customer preferences for effective website design.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>SEO-Friendly Website Development:</strong> We build websites with search engine optimization in mind, helping you rank higher on Google in Chhindwara and across India.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Fast Loading Websites:</strong> Our websites are optimized for speed, providing a better user experience and improved SEO performance.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Ongoing Website Support:</strong> We don't just build and leave. We provide continuous support and maintenance for your website after launch.</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Website Development Process</h3>
              
              <div className="space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    1
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Discovery & Planning</h4>
                    <p className="text-gray-700">We learn about your business, goals, and target audience in Chhindwara to create a strategic website plan.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    2
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Website Design & Prototyping</h4>
                    <p className="text-gray-700">We create wireframes and visual designs for your approval before development begins.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    3
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Website Development</h4>
                    <p className="text-gray-700">Our developers build your website with clean, efficient code and modern technologies for optimal performance.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    4
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Testing & Launch</h4>
                    <p className="text-gray-700">We thoroughly test your website before launching it to ensure everything works perfectly for your Chhindwara audience.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    5
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Ongoing Website Support</h4>
                    <p className="text-gray-700">We provide maintenance, updates, and support to keep your website running smoothly after launch.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden sticky top-24">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Ready for a Professional Website?</h3>
                <p className="mb-0">Contact us today for a free consultation and quote on website development.</p>
              </div>
              
              <div className="p-6">
                <form className="space-y-4">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Name"
                      aria-label="Your Name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Email</label>
                    <input 
                      type="email" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Email"
                      aria-label="Your Email"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Phone</label>
                    <input 
                      type="tel" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Phone"
                      aria-label="Your Phone"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Message</label>
                    <textarea 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      rows={4}
                      placeholder="Tell us about your website project"
                      aria-label="Your Message"
                    ></textarea>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="w-full bg-zolo-blue hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-md transition duration-300"
                  >
                    Get a Free Website Quote
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
